export type PartnerDetailsTab = "info" | "branches" | "payouts";

export const TABS: { key: PartnerDetailsTab; label: string }[] = [
    { key: "info", label: "Данные" },
    { key: "branches", label: "Заведения" },
    { key: "payouts", label: "Выплаты" },
];

export const BRANCHES_PAGE_SIZE = 20;

// Вкладка показывает всю историю: границы шире любой реальной даты выплаты.
export const ALL_TIME_FROM = 0;
export const ALL_TIME_TO = new Date(2100, 0, 1).getTime();

export const DEFAULT_CURRENCY_ID = "RUB";
